{
  "de": {
    "fileSharing": {
      "public": {
        "empty": {
          "title": "Noch keine Dateien",
          "description": "In dieser Freigabe liegen noch keine Dateien."
        }
      }
    }
  }
}
